import { CommonAPIService } from 'src/servicehandlers/CommonHandler';

export class CurriculumsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getAllCurriculums(router){
    const url = `/api/curriculum`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getCurriculumById(id, router) {
    const url = `/api/curriculum/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  createCurriculum(params, router) {
    const url = `/api/curriculum`;
    return this.CommonAPIService.postCall(url, params, router);
  }
  updateCurriculumLogo(id, params) {
    const url = `/api/curriculum/logo/${id}`;
    return this.CommonAPIService.newFileCall(url, params);
  }

  updateCurriculum(id, params, router) {
    const url = `/api/curriculum/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteCurriculum(id, router) {
    const url = `/api/curriculum/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  getAllCurriculumStages(router){
    const url = `/api/curriculum/stages`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getStagesForCurriculum(id, router) {
    const url = `/api/curriculum/stagesFor/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getCurriculumStageById(id, router) {
    const url = `/api/curriculum/stages/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  createCurriculumStage(params, router) {
    const url = `/api/curriculum/stages`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateCurriculumStage(id, params, router) {
    const url = `/api/curriculum/stages/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  duplicateCurriculumStage(id, router) {
    const url = `/api/curriculum/stages/duplicate/${id}`;
    return this.CommonAPIService.postCall(url, '', router);
  }

  deleteCurriculumStage(id, router) {
    const url = `/api/curriculum/stages/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  getLessonsForStage(id, router) {
    const url = `/api/curriculum/lessonsFor/stage/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

}
export default CurriculumsAPIService;
